// tslint:disable
import { Injectable } from '@angular/core';

import { DwItem, DwItemDetail, DwQuery, DwOrmData } from '@devwareapps/devware-cap';
import * as EnterpriseMetaData from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/************************************************
   Generated with the Devware CAP CLI 4.4.44
   Code Gen Name   Accidents
   API Url         https://wappsdev.wachter.com/DevwareCapApi/

   Generated By    MSI/mlt
   Generate On     8/29/2024 11:04:03 AM
************************************************/

export enum AccidentsMetaDataItemNames {
    CodeValue = 'CodeValue',
    EthosCodeValue = 'Ethos_CodeValue',
    EthosCodeValueCustom = 'Ethos_CodeValueCustom',
    EthosUser = 'Ethos_User',
    EthosUserDiff = 'Ethos_UserDiff',
    EthosUserSkill = 'Ethos_UserSkill',
    EthosWachterDepartment = 'Ethos_WachterDepartment',
    MedicalRecord = 'MedicalRecord',
    RoEthosUser = 'roEthos_User',
    RoEthosUserOriginal = 'roEthos_UserOriginal',
    RoVehicleAccidents = 'roVehicleAccidents',
    RoWorkplaceAccident = 'roWorkplaceAccident',
    RoWorkplaceAccidentNotes = 'roWorkplaceAccidentNotes',
    Vehicle = 'Vehicle',
    VehicleAccident = 'VehicleAccident',
    WageExpense = 'WageExpense',
    WorkplaceAccident = 'workplaceAccident',
}

export enum AccidentsMetaDataLookups {
    CodeValueAccessControl = 2811,
    CodeValueAccessControlAdditionalOptions = 1849,
    CodeValueCCTVTypesOfInstall = 1851,
    CodeValueCompanyLicenseStatus = 2877,
    CodeValueDifferentTypeOfElectrical = 1846,
    CodeValueElectricalNewWorkType = 1848,
    CodeValueEquipmentRequestJobContext = 2995,
    CodeValueFireAlarmDemoOrInstall = 1850,
    CodeValueFleetAuctionStatus = 2954,
    CodeValueFleetAuctionStatusActive = 2964,
    CodeValueFleetAuctionStatusCompleted = 2965,
    CodeValueFleetAuctionStatusNotStarted = 2963,
    CodeValueFleetDriveTrain = 2947,
    CodeValueFleetFuelType = 2948,
    CodeValueFleetOwnershipType = 2945,
    CodeValueFleetVehicleCondition = 2949,
    CodeValueFleetVehicleStatus = 2944,
    CodeValueFleetVehicleType = 2946,
    CodeValueInspectionState = 1866,
    CodeValueInspectionTimeOfDay = 1863,
    CodeValueLicenseStatus = 1467,
    CodeValueMORSubTypeByIssueType = 1513,
    CodeValuePassFail = 1867,
    CodeValuePerformWork = 1803,
    CodeValuePermitCableType = 1799,
    CodeValuePermitRequestAddAction = 2865,
    CodeValuePermitRequestElectricalOutletType = 1845,
    CodeValuePermitRequestType = 1798,
    CodeValuePermitStatus = 1801,
    CodeValueTypesOfElectrical = 1847,
    CodeValueVehicleAccidentFormVersion = 3000,
    CodeValueVehicleAccidentLineOfBusiness = 3001,
    CodeValueAccidentType = 1541,
    CodeValueAccidentTypeWorkplace = 1648,
    CodeValueAirportPlan = 1596,
    CodeValueAtFault = 1542,
    CodeValueBodyPart = 1684,
    CodeValueBodySide = 1685,
    CodeValueBusinessPlanReviewAccidentType = 1587,
    CodeValueClaimStatus = 1544,
    CodeValueEmployeeTrainingNeeded = 1525,
    CodeValueEmployeeTrainingNeededConclusion = 1532,
    CodeValueEmployeeTrainingNeededStatus = 1534,
    CodeValueEmsWorkStatus = 1638,
    CodeValueEquipmentDelivery = 1453,
    CodeValueEthosJobNumberType = 2868,
    CodeValueEthosSkill = 2840,
    CodeValueFiveStarRatingValue = 1616,
    CodeValueInjuryType = 1683,
    CodeValueInspectionResults = 1869,
    CodeValueInsuranceCompany = 1545,
    CodeValueJobType = 2821,
    CodeValueLodgingPlan = 1598,
    CodeValueMemoOfRecordIssueSubTypeAll = 1515,
    CodeValueMemoOfRecordConclusion = 1511,
    CodeValueMemoOfRecordEmployeeType = 1510,
    CodeValueMemoOfRecordIssueType = 1512,
    CodeValueMORStatus = 1517,
    CodeValuePayJobChangeDepartmentRole = 1485,
    CodeValuePayJobChangeStatus = 1481,
    CodeValuePayJobChangeType = 1486,
    CodeValuePermitTeam = 1731,
    CodeValuePermitType = 1726,
    CodeValuePlenumOrRiser = 1727,
    CodeValueTechType = 1586,
    CodeValueTermResignType = 1487,
    CodeValueTransportationPlan = 1597,
    CodeValueTravelMode = 1595,
    CodeValueTravelRequestStatus = 1601,
    CodeValueTravelType = 1599,
    CodeValueVechicleRepaired = 1543,
    CodeValueWorkerType = 1792,
    CodeValueWorkersCompClaimStatus = 2862,
    CodeValueWorksiteType = 1647,
    EmployeesByDeptIncTrainees = 2812,
    EthosInvoiceDeliveryType = 1707,
    EthosUserTypeCodeValue = 1690,
    EthosCodeValueAllItems = 1631,
    EthosCodeValueCustomAllItems = 1733,
    EthosUserBySupervisor = 1758,
    EthosUserBySupervisorPlusIndirect = 1773,
    EthosUserByUsersDepartment = 1582,
    ETHOSUSERNSPLBUOfficeActiveEmployees = 1696,
    ETHOSUSERWachterEmployeesActiveEmployees = 1464,
    EthosUserAllItems = 1416,
    EthosUserNSPUsers = 2981,
    EthosUserEmployeeGroups = 2858,
    EthosUserDiffAllItems = 1623,
    EthosUserSkillAllItems = 1413,
    EthosWachterDepartmentByDivision = 2991,
    EthosWachterDepartmentAllItems = 1391,
    EthosWachterDepartmentAllItemsSimple = 2994,
    FleetAuctionStatusWorkflow = 2979,
    MedicalRecordAllItems = 2932,
    PermitJobTypeLookup = 1811,
    PermitRequestJobTypeLookupNoJobNumber = 1873,
    Permitv2JobTypeLookupNoJobNumber = 2845,
    PlenumRiseOutdoor = 1796,
    ProjectKickoffBillingFrequency = 2923,
    ProjectKickoffBillingType = 2922,
    RoEthosUserActiveOnly = 2837,
    RoEthosUserAllActiveThenInactive = 2889,
    RoEthosUserAllItems = 1422,
    RoEthosUserOriginalAllItems = 1753,
    RoVehicleAccidentsAllItems = 1552,
    RoWorkplaceAccidentAllItems = 1730,
    RoWorkplaceAccidentNotesAllItems = 2906,
    TrustCodeValueAllItems = 1388,
    VehicleAllItems = 1540,
    VehicleAccidentAllItems = 1538,
    WachterDivisions = 1858,
    WageExpenseAllItems = 2905,
    WorkplaceAccidentAllItems = 1646,
}

@Injectable({
    providedIn: 'root'
})
export class AccidentsMetaDataService {

    CodeValue : CodeValueMetaData = new CodeValueMetaData();
    EthosCodeValue : EthosCodeValueMetaData = new EthosCodeValueMetaData();
    EthosCodeValueCustom : EthosCodeValueCustomMetaData = new EthosCodeValueCustomMetaData();
    EthosUser : EthosUserMetaData = new EthosUserMetaData();
    EthosUserDiff : EthosUserDiffMetaData = new EthosUserDiffMetaData();
    EthosUserSkill : EthosUserSkillMetaData = new EthosUserSkillMetaData();
    EthosWachterDepartment : EthosWachterDepartmentMetaData = new EthosWachterDepartmentMetaData();
    MedicalRecord : MedicalRecordMetaData = new MedicalRecordMetaData();
    RoEthosUser : RoEthosUserMetaData = new RoEthosUserMetaData();
    RoEthosUserOriginal : RoEthosUserOriginalMetaData = new RoEthosUserOriginalMetaData();
    RoVehicleAccidents : RoVehicleAccidentsMetaData = new RoVehicleAccidentsMetaData();
    RoWorkplaceAccident : RoWorkplaceAccidentMetaData = new RoWorkplaceAccidentMetaData();
    RoWorkplaceAccidentNotes : RoWorkplaceAccidentNotesMetaData = new RoWorkplaceAccidentNotesMetaData();
    Vehicle : VehicleMetaData = new VehicleMetaData();
    VehicleAccident : VehicleAccidentMetaData = new VehicleAccidentMetaData();
    WageExpense : WageExpenseMetaData = new WageExpenseMetaData();
    WorkplaceAccident : WorkplaceAccidentMetaData = new WorkplaceAccidentMetaData();
}

// Generated Classes for MetaData service
export class CodeValueMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CodeValue.';

    constructor() {
        this.ItemDetail.ItemId=2385;
        this.ItemDetail.ItemName='CodeValue';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CodeValueId : string = this.i + 'CodeValueId';
    CodeSetId : string = this.i + 'CodeSetId';
    Display : string = this.i + 'Display';
    Meaning : string = this.i + 'Meaning';
    Description : string = this.i + 'Description';
    CodeValueOrder : string = this.i + 'CodeValueOrder';
    IsActive : string = this.i + 'IsActive';

    Relations = {
            /** Relation: Vehicle Accident - Accident At Fault Cv - Many */
            VehicleAccidentByAccidentAtFaultCv : {
                RelationName: 'CodeValue|VehicleAccident|AccidentAtFaultCv',
                FieldPrefix: 'AccidentAtFaultCvVehicleAccident',
                PropertyName: 'AccidentAtFaultCvVehicleAccident'
            },
            /** Relation: Vehicle Accident - Accident Type Cv - Many */
            VehicleAccidentByAccidentTypeCv : {
                RelationName: 'CodeValue|VehicleAccident|AccidentTypeCv',
                FieldPrefix: 'AccidentTypeCvVehicleAccident',
                PropertyName: 'AccidentTypeCvVehicleAccident'
            },
            /** Relation: Vehicle Accident - Claim Insurance Company Cv - Many */
            VehicleAccidentByClaimInsuranceCompanyCv : {
                RelationName: 'CodeValue|VehicleAccident|ClaimInsuranceCompanyCv',
                FieldPrefix: 'ClaimInsuranceCompanyCvVehicleAccident',
                PropertyName: 'ClaimInsuranceCompanyCvVehicleAccident'
            },
            /** Relation: Vehicle Accident - Claim Status Cv - Many */
            VehicleAccidentByClaimStatusCv : {
                RelationName: 'CodeValue|VehicleAccident|ClaimStatusCv',
                FieldPrefix: 'ClaimStatusCvVehicleAccident',
                PropertyName: 'ClaimStatusCvVehicleAccident'
            },
            /** Relation: Vehicle Accident - Vehicle Repaired Cv - Many */
            VehicleAccidentByVehicleRepairedCv : {
                RelationName: 'CodeValue|VehicleAccident|VehicleRepairedCv',
                FieldPrefix: 'VehicleRepairedCvVehicleAccident',
                PropertyName: 'VehicleRepairedCvVehicleAccident'
            },
            /** Relation: Vehicle Accident - Line Of Business Cv - Many */
            VehicleAccidentByLineOfBusinessCv : {
                RelationName: 'CodeValue|VehicleAccident|LineOfBusinessCv',
                FieldPrefix: 'LineOfBusinessCvVehicleAccident',
                PropertyName: 'LineOfBusinessCvVehicleAccident'
            },
            /** Relation: Workplace Accident - Injury Type Cv - Many */
            WorkplaceAccidentByInjuryTypeCv : {
                RelationName: 'CodeValue|workplaceAccident|InjuryTypeCv',
                FieldPrefix: 'InjuryTypeCvWorkplaceAccident',
                PropertyName: 'InjuryTypeCvWorkplaceAccident'
            },
            /** Relation: Workplace Accident - Accident Type Cv - Many */
            WorkplaceAccidentByAccidentTypeCv : {
                RelationName: 'CodeValue|workplaceAccident|AccidentTypeCv',
                FieldPrefix: 'AccidentTypeCvWorkplaceAccident',
                PropertyName: 'AccidentTypeCvWorkplaceAccident'
            },
            /** Relation: Workplace Accident - Body Part Cv - Many */
            WorkplaceAccidentByBodyPartCv : {
                RelationName: 'CodeValue|workplaceAccident|BodyPartCv',
                FieldPrefix: 'BodyPartCvWorkplaceAccident',
                PropertyName: 'BodyPartCvWorkplaceAccident'
            },
            /** Relation: Workplace Accident - Body Side Cv - Many */
            WorkplaceAccidentByBodySideCv : {
                RelationName: 'CodeValue|workplaceAccident|BodySideCv',
                FieldPrefix: 'BodySideCvWorkplaceAccident',
                PropertyName: 'BodySideCvWorkplaceAccident'
            },
            /** Relation: Workplace Accident - Worksite Type Cv - Many */
            WorkplaceAccidentByWorksiteTypeCv : {
                RelationName: 'CodeValue|workplaceAccident|WorksiteTypeCv',
                FieldPrefix: 'WorksiteTypeCvWorkplaceAccident',
                PropertyName: 'WorksiteTypeCvWorkplaceAccident'
            },
            /** Relation: Workplace Accident - Claim Status Cv - Many */
            WorkplaceAccidentByClaimStatusCv : {
                RelationName: 'CodeValue|workplaceAccident|ClaimStatusCv',
                FieldPrefix: 'ClaimStatusCvWorkplaceAccident',
                PropertyName: 'ClaimStatusCvWorkplaceAccident'
            },
            /** Relation: Workplace Accident - In House Claim Status Cv - Many */
            WorkplaceAccidentByInHouseClaimStatusCv : {
                RelationName: 'CodeValue|workplaceAccident|InHouseClaimStatusCv',
                FieldPrefix: 'InHouseClaimStatusCvWorkplaceAccident',
                PropertyName: 'InHouseClaimStatusCvWorkplaceAccident'
            },
    };
}

export class EthosCodeValueMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_CodeValue.';

    constructor() {
        this.ItemDetail.ItemId=2579;
        this.ItemDetail.ItemName='Ethos_CodeValue';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CodeValueId : string = this.i + 'CodeValueId';
    CodeSetId : string = this.i + 'CodeSetId';
    Display : string = this.i + 'Display';
    Meaning : string = this.i + 'Meaning';
    Description : string = this.i + 'Description';
    CodeValueOrder : string = this.i + 'CodeValueOrder';
    IsActive : string = this.i + 'IsActive';
    ImagePath : string = this.i + 'ImagePath';

    Relations = {
            /** Relation: Ethos User - User Type Cv - Many */
            EthosUserByUserTypeCv : {
                RelationName: 'Ethos_User|Ethos_CodeValue|UserTypeCv',
                FieldPrefix: 'UserTypeCvEthosUser',
                PropertyName: 'UserTypeCvEthosUser'
            },
            /** Relation: Ethos User - Resource Group Cv - Many */
            EthosUserByResourceGroupCv : {
                RelationName: 'Ethos_CodeValue|Ethos_User|ResourceGroupCv',
                FieldPrefix: 'ResourceGroupCvEthosUser',
                PropertyName: 'ResourceGroupCvEthosUser'
            },
            /** Relation: User Skill - Skill Cv - Many */
            EthosUserSkillBySkillCv : {
                RelationName: 'Ethos_CodeValue|Ethos_UserSkill|SkillCv',
                FieldPrefix: 'SkillCvEthosUserSkill',
                PropertyName: 'SkillCvEthosUserSkill'
            },
            /** Relation: Wachter Department - Department Type Cv - Many */
            EthosWachterDepartmentByDepartmentTypeCv : {
                RelationName: 'Ethos_CodeValue|Ethos_WachterDepartment|DepartmentTypeCv',
                FieldPrefix: 'DepartmentTypeCvEthosWachterDepartment',
                PropertyName: 'DepartmentTypeCvEthosWachterDepartment'
            },
            /** Relation: Ro Ethos User - Resource Group Cv - Many */
            RoEthosUserByResourceGroupCv : {
                RelationName: 'Ethos_CodeValue|roEthos_User|ResourceGroupCv',
                FieldPrefix: 'ResourceGroupCvRoEthosUser',
                PropertyName: 'ResourceGroupCvRoEthosUser'
            },
            /** Relation: Ro Ethos User - User Type Cv - Many */
            RoEthosUserByUserTypeCv : {
                RelationName: 'Ethos_CodeValue|roEthos_User|UserTypeCv',
                FieldPrefix: 'UserTypeCvRoEthosUser',
                PropertyName: 'UserTypeCvRoEthosUser'
            },
    };
}

export class EthosCodeValueCustomMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_CodeValueCustom.';

    constructor() {
        this.ItemDetail.ItemId=2643;
        this.ItemDetail.ItemName='Ethos_CodeValueCustom';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CodeValueCustomId : string = this.i + 'CodeValueCustomId';
    CodeSetId : string = this.i + 'CodeSetId';
    Display : string = this.i + 'Display';
    Meaning : string = this.i + 'Meaning';
    Description : string = this.i + 'Description';
    CodeValueOrder : string = this.i + 'CodeValueOrder';
    IsActive : string = this.i + 'IsActive';

    Relations = {
    };
}

export class EthosUserMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_User.';

    constructor() {
        this.ItemDetail.ItemId=2413;
        this.ItemDetail.ItemName='Ethos_User';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    EmployeeType : string = this.i + 'EmployeeType';
    StateProvinceId : string = this.i + 'StateProvinceId';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    CustomerId : string = this.i + 'CustomerId';
    SubcontractorId : string = this.i + 'SubcontractorId';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    IsVaxxed : string = this.i + 'isVaxxed';

    Relations = {
            /** Relation: Ethos Code Value - User Type */
            EthosCodeValueByUserTypeCv : {
                RelationName: 'Ethos_User|Ethos_CodeValue|UserTypeCv',
                FieldPrefix: 'UserTypeCvEthosCodeValue',
                PropertyName: 'UserTypeCvEthosCodeValue'
            },
            /** Relation: Ethos Code Value - Resource Group Cv */
            EthosCodeValueByResourceGroupCv : {
                RelationName: 'Ethos_CodeValue|Ethos_User|ResourceGroupCv',
                FieldPrefix: 'ResourceGroupCvEthosCodeValue',
                PropertyName: 'ResourceGroupCvEthosCodeValue'
            },
            /** Relation: Ethos User - Supervisor User - One */
            EthosUserBySupervisorUserId : {
                RelationName: 'Supervisor_User',
                FieldPrefix: 'SupervisorEthosUser',
                PropertyName: 'SupervisorEthosUser'
            },
            /** Relation: Wachter Department */
            EthosWachterDepartment : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentId',
                FieldPrefix: 'EthosWachterDepartment',
                PropertyName: 'EthosWachterDepartment'
            },
            /** Relation: Ethos User Diff - Many */
            EthosUserDiffByEthosUserId : {
                RelationName: 'Ethos_User|Ethos_UserDiff|Ethos_UserId',
                FieldPrefix: 'EthosEthosUserDiff',
                PropertyName: 'EthosEthosUserDiff'
            },
            /** Relation: User Skill */
            EthosUserSkill : {
                RelationName: 'Ethos_User|Ethos_UserSkill|UserId',
                FieldPrefix: 'EthosUserSkill',
                PropertyName: 'EthosUserSkill'
            },
            /** Relation: Wachter Department - Department Director - Many */
            EthosWachterDepartmentByDepartmentDirectorUserId : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentDirectorUserId',
                FieldPrefix: 'DepartmentDirectorEthosWachterDepartment',
                PropertyName: 'DepartmentDirectorEthosWachterDepartment'
            },
            /** Relation: Wachter Department - Department Manager - Many */
            EthosWachterDepartmentByDepartmentManagerUserId : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentManagerUserId',
                FieldPrefix: 'DepartmentManagerEthosWachterDepartment',
                PropertyName: 'DepartmentManagerEthosWachterDepartment'
            },
            /** Relation: Wachter Department - Department Asst Manager - Many */
            EthosWachterDepartmentByDepartmentAsstManagerUserId : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentAsstManagerUserId',
                FieldPrefix: 'DepartmentAsstManagerEthosWachterDepartment',
                PropertyName: 'DepartmentAsstManagerEthosWachterDepartment'
            },
            /** Relation: Medical Record - Created By - Many */
            MedicalRecordByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|MedicalRecord|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosMedicalRecord',
                PropertyName: 'CreatedByEthosMedicalRecord'
            },
            /** Relation: Medical Record - Modified By - Many */
            MedicalRecordByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|MedicalRecord|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosMedicalRecord',
                PropertyName: 'ModifiedByEthosMedicalRecord'
            },
            /** Relation: Ro Ethos User */
            RoEthosUser : {
                RelationName: 'Ethos_User|roEthos_User|UserId',
                FieldPrefix: 'RoEthosUser',
                PropertyName: 'RoEthosUser'
            },
            /** Relation: Ro Ethos User - Supervisor - Many */
            RoEthosUserBySupervisorUserId : {
                RelationName: 'Ethos_User|roEthos_User|SupervisorUserId',
                FieldPrefix: 'SupervisorRoEthosUser',
                PropertyName: 'SupervisorRoEthosUser'
            },
            /** Relation: Vehicle - Modified By - Many */
            VehicleByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Vehicle|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosVehicle',
                PropertyName: 'ModifiedByEthosVehicle'
            },
            /** Relation: Vehicle - Createdby - Many */
            VehicleByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|Vehicle|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosVehicle',
                PropertyName: 'CreatedbyEthosVehicle'
            },
            /** Relation: Vehicle Accident - Modified By - Many */
            VehicleAccidentByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|VehicleAccident|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosVehicleAccident',
                PropertyName: 'ModifiedByEthosVehicleAccident'
            },
            /** Relation: Vehicle Accident - Createdby - Many */
            VehicleAccidentByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|VehicleAccident|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosVehicleAccident',
                PropertyName: 'CreatedbyEthosVehicleAccident'
            },
            /** Relation: Wage Expense - Created By - Many */
            WageExpenseByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|WageExpense|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosWageExpense',
                PropertyName: 'CreatedByEthosWageExpense'
            },
            /** Relation: Wage Expense - Modified By - Many */
            WageExpenseByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|WageExpense|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosWageExpense',
                PropertyName: 'ModifiedByEthosWageExpense'
            },
            /** Relation: Workplace Accident - Modified By - Many */
            WorkplaceAccidentByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|workplaceAccident|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosWorkplaceAccident',
                PropertyName: 'ModifiedByEthosWorkplaceAccident'
            },
            /** Relation: Workplace Accident - Createdby - Many */
            WorkplaceAccidentByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|workplaceAccident|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosWorkplaceAccident',
                PropertyName: 'CreatedbyEthosWorkplaceAccident'
            },
            /** Relation: Workplace Accident - Many */
            WorkplaceAccidentByEthosUserId : {
                RelationName: 'Ethos_User|workplaceAccident|Ethos_UserId',
                FieldPrefix: 'EthosWorkplaceAccident',
                PropertyName: 'EthosWorkplaceAccident'
            },
    };
}

export class EthosUserDiffMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_UserDiff.';

    constructor() {
        this.ItemDetail.ItemId=2572;
        this.ItemDetail.ItemName='Ethos_UserDiff';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EthosUserDiffId : string = this.i + 'Ethos_UserDiffId';
    EthosUserId : string = this.i + 'Ethos_UserId';
    FieldName : string = this.i + 'FieldName';
    OldValue : string = this.i + 'OldValue';
    NewValue : string = this.i + 'NewValue';
    ChangedDateTime : string = this.i + 'ChangedDateTime';

    Relations = {
            /** Relation: Ethos User - User */
            EthosUserByEthosUserId : {
                RelationName: 'Ethos_User|Ethos_UserDiff|Ethos_UserId',
                FieldPrefix: 'EthosEthosUser',
                PropertyName: 'EthosEthosUser'
            },
    };
}

export class EthosUserSkillMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_UserSkill.';

    constructor() {
        this.ItemDetail.ItemId=2410;
        this.ItemDetail.ItemName='Ethos_UserSkill';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserSkillId : string = this.i + 'UserSkillId';
    UserId : string = this.i + 'UserId';
    SkillCv : string = this.i + 'SkillCv';
    Meaning : string = this.i + 'Meaning';
    Display : string = this.i + 'Display';

    Relations = {
            /** Relation: Ethos Code Value - Skill */
            EthosCodeValueBySkillCv : {
                RelationName: 'Ethos_CodeValue|Ethos_UserSkill|SkillCv',
                FieldPrefix: 'SkillCvEthosCodeValue',
                PropertyName: 'SkillCvEthosCodeValue'
            },
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_User|Ethos_UserSkill|UserId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
    };
}

export class EthosWachterDepartmentMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_WachterDepartment.';

    constructor() {
        this.ItemDetail.ItemId=2388;
        this.ItemDetail.ItemName='Ethos_WachterDepartment';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    DepartmentTypeCv : string = this.i + 'DepartmentTypeCv';
    DepartmentTypeMeaning : string = this.i + 'DepartmentTypeMeaning';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    DepartmentDirectorUserId : string = this.i + 'DepartmentDirectorUserId';
    IsDeleted : string = this.i + 'IsDeleted';
    DepartmentManagerUserId : string = this.i + 'DepartmentManagerUserId';
    DepartmentAsstManagerUserId : string = this.i + 'DepartmentAsstManagerUserId';
    JobNumberId : string = this.i + 'JobNumberId';
    AxIntegrationId : string = this.i + 'AxIntegrationId';
    JobNumberPhaseId : string = this.i + 'JobNumberPhaseId';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';

    Relations = {
            /** Relation: Ethos Code Value - Department Type */
            EthosCodeValueByDepartmentTypeCv : {
                RelationName: 'Ethos_CodeValue|Ethos_WachterDepartment|DepartmentTypeCv',
                FieldPrefix: 'DepartmentTypeCvEthosCodeValue',
                PropertyName: 'DepartmentTypeCvEthosCodeValue'
            },
            /** Relation: Ethos User - Department Director User */
            EthosUserByDepartmentDirectorUserId : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentDirectorUserId',
                FieldPrefix: 'DepartmentDirectorEthosUser',
                PropertyName: 'DepartmentDirectorEthosUser'
            },
            /** Relation: Ethos User - Department Manager User */
            EthosUserByDepartmentManagerUserId : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentManagerUserId',
                FieldPrefix: 'DepartmentManagerEthosUser',
                PropertyName: 'DepartmentManagerEthosUser'
            },
            /** Relation: Ethos User - Department Asst Manager User */
            EthosUserByDepartmentAsstManagerUserId : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentAsstManagerUserId',
                FieldPrefix: 'DepartmentAsstManagerEthosUser',
                PropertyName: 'DepartmentAsstManagerEthosUser'
            },
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_User|Ethos_WachterDepartment|DepartmentId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
            /** Relation: Ro Ethos User */
            RoEthosUser : {
                RelationName: 'Ethos_WachterDepartment|roEthos_User|WachterDepartmentId',
                FieldPrefix: 'RoEthosUser',
                PropertyName: 'RoEthosUser'
            },
            /** Relation: Workplace Accident - Department - Many */
            WorkplaceAccidentByDepartmentId : {
                RelationName: 'Ethos_WachterDepartment|workplaceAccident|DepartmentId',
                FieldPrefix: 'DepartmentIdWorkplaceAccident',
                PropertyName: 'DepartmentIdWorkplaceAccident'
            },
    };
}

export class MedicalRecordMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'MedicalRecord.';

    constructor() {
        this.ItemDetail.ItemId=3413;
        this.ItemDetail.ItemName='MedicalRecord';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    MedicalRecordId : string = this.i + 'MedicalRecordId';
    WorkplaceAccidentId : string = this.i + 'WorkplaceAccidentId';
    Details : string = this.i + 'Details';
    TreatmentDateTime : string = this.i + 'TreatmentDateTime';
    Cost : string = this.i + 'Cost';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';

    Relations = {
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|MedicalRecord|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|MedicalRecord|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Workplace Accident */
            WorkplaceAccident : {
                RelationName: 'WorkplaceAccident|MedicalRecord|WorkplaceAccidentId',
                FieldPrefix: 'WorkplaceAccident',
                PropertyName: 'WorkplaceAccident'
            },
    };
}

export class RoEthosUserMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEthos_User.';

    constructor() {
        this.ItemDetail.ItemId=2419;
        this.ItemDetail.ItemName='roEthos_User';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    TeamName : string = this.i + 'TeamName';
    TeamShortName : string = this.i + 'TeamShortName';
    TeamNickName : string = this.i + 'TeamNickName';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    NameLastFirst : string = this.i + 'NameLastFirst';
    NameLastPrefered : string = this.i + 'NameLastPrefered';
    NameLastFirstPrefered : string = this.i + 'NameLastFirstPrefered';
    NameFirstLast : string = this.i + 'NameFirstLast';
    NamePreferedLast : string = this.i + 'NamePreferedLast';
    NameFirstPreferedLast : string = this.i + 'NameFirstPreferedLast';
    NameFirstMiddleLast : string = this.i + 'NameFirstMiddleLast';
    NamePreferedMidInitialLast : string = this.i + 'NamePreferedMidInitialLast';
    NameLastFirstPreferedStatus : string = this.i + 'NameLastFirstPreferedStatus';
    EmployeeType : string = this.i + 'EmployeeType';
    StateProvinceId : string = this.i + 'StateProvinceId';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    NameLastFirstPreferedType : string = this.i + 'NameLastFirstPreferedType';
    IsActive : string = this.i + 'IsActive';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    BirthMonthDate : string = this.i + 'BirthMonthDate';
    TerritoryId : string = this.i + 'TerritoryId';
    TerritoryName : string = this.i + 'TerritoryName';
    Company : string = this.i + 'Company';
    LicenseCount : string = this.i + 'LicenseCount';
    AXId : string = this.i + 'AXId';
    YrsService : string = this.i + 'YrsService';
    StaffingAgencyName : string = this.i + 'StaffingAgencyName';

    Relations = {
            /** Relation: Ethos Code Value - Resource Group Cv */
            EthosCodeValueByResourceGroupCv : {
                RelationName: 'Ethos_CodeValue|roEthos_User|ResourceGroupCv',
                FieldPrefix: 'ResourceGroupCvEthosCodeValue',
                PropertyName: 'ResourceGroupCvEthosCodeValue'
            },
            /** Relation: Ethos Code Value - User Type */
            EthosCodeValueByUserTypeCv : {
                RelationName: 'Ethos_CodeValue|roEthos_User|UserTypeCv',
                FieldPrefix: 'UserTypeCvEthosCodeValue',
                PropertyName: 'UserTypeCvEthosCodeValue'
            },
            /** Relation: Ro Ethos User - Supervisor User - One */
            RoEthosUserBySupervisorUserId : {
                RelationName: 'roEthos_User|roEthos_User|SupervisorId',
                FieldPrefix: 'SupervisorRoEthosUser',
                PropertyName: 'SupervisorRoEthosUser'
            },
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_User|roEthos_User|UserId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
            /** Relation: Ethos User - Supervisor User */
            EthosUserBySupervisorUserId : {
                RelationName: 'Ethos_User|roEthos_User|SupervisorUserId',
                FieldPrefix: 'SupervisorEthosUser',
                PropertyName: 'SupervisorEthosUser'
            },
            /** Relation: Wachter Department */
            EthosWachterDepartment : {
                RelationName: 'Ethos_WachterDepartment|roEthos_User|WachterDepartmentId',
                FieldPrefix: 'EthosWachterDepartment',
                PropertyName: 'EthosWachterDepartment'
            },
            /** Relation: Vehicle Accident - Employee - Many */
            VehicleAccidentByEmployeeId : {
                RelationName: 'VehicleAccident|roEthos_User|UserId',
                FieldPrefix: 'EmployeeIdVehicleAccident',
                PropertyName: 'EmployeeIdVehicleAccident'
            },
            /** Relation: Vehicle Accident - Createdby Ethos  - Many */
            VehicleAccidentByCreatedbyEthosUserId : {
                RelationName: 'VehicleAccident|roEthos_User|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedbyEthosVehicleAccident',
                PropertyName: 'CreatedbyEthosVehicleAccident'
            },
            /** Relation: Vehicle Accident - Modified By Ethos  - Many */
            VehicleAccidentByModifiedByEthosUserId : {
                RelationName: 'VehicleAccident|roEthos_User|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosVehicleAccident',
                PropertyName: 'ModifiedByEthosVehicleAccident'
            },
    };
}

export class RoEthosUserOriginalMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEthos_UserOriginal.';

    constructor() {
        this.ItemDetail.ItemId=2661;
        this.ItemDetail.ItemName='roEthos_UserOriginal';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    AXId : string = this.i + 'AXId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    EmployeeType : string = this.i + 'EmployeeType';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    BirthMonthDate : string = this.i + 'BirthMonthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsActive : string = this.i + 'IsActive';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceId : string = this.i + 'StateProvinceId';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    TerritoryId : string = this.i + 'TerritoryId';
    TerritoryName : string = this.i + 'TerritoryName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    TeamName : string = this.i + 'TeamName';
    TeamShortName : string = this.i + 'TeamShortName';
    TeamNickName : string = this.i + 'TeamNickName';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    Company : string = this.i + 'Company';
    LicenseCount : string = this.i + 'LicenseCount';
    NameLastFirst : string = this.i + 'NameLastFirst';
    NameLastPrefered : string = this.i + 'NameLastPrefered';
    NameLastFirstPrefered : string = this.i + 'NameLastFirstPrefered';
    NameFirstLast : string = this.i + 'NameFirstLast';
    NamePreferedLast : string = this.i + 'NamePreferedLast';
    NameFirstPreferedLast : string = this.i + 'NameFirstPreferedLast';
    NameFirstMiddleLast : string = this.i + 'NameFirstMiddleLast';
    NamePreferedMidInitialLast : string = this.i + 'NamePreferedMidInitialLast';
    NameLastFirstPreferedStatus : string = this.i + 'NameLastFirstPreferedStatus';
    NameLastFirstPreferedType : string = this.i + 'NameLastFirstPreferedType';

    Relations = {
    };
}

export class RoVehicleAccidentsMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roVehicleAccidents.';

    constructor() {
        this.ItemDetail.ItemId=2519;
        this.ItemDetail.ItemName='roVehicleAccidents';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    VehicleAccidentId : string = this.i + 'VehicleAccidentId';
    EmployeeId : string = this.i + 'EmployeeId';
    PhoneNumber : string = this.i + 'PhoneNumber';
    WJID : string = this.i + 'WJID';
    AccidentDateTime : string = this.i + 'AccidentDateTime';
    AuthorityContacted : string = this.i + 'AuthorityContacted';
    ReportNumber : string = this.i + 'ReportNumber';
    DriverStreetAddress : string = this.i + 'DriverStreetAddress';
    DriverCity : string = this.i + 'DriverCity';
    DriverState : string = this.i + 'DriverState';
    DriverZip : string = this.i + 'DriverZip';
    AccidentAddress : string = this.i + 'AccidentAddress';
    AccidentCity : string = this.i + 'AccidentCity';
    AccidentState : string = this.i + 'AccidentState';
    AccidentZip : string = this.i + 'AccidentZip';
    AccidentTypeCv : string = this.i + 'AccidentTypeCv';
    AccidentAtFaultCv : string = this.i + 'AccidentAtFaultCv';
    VehicleRepairedCv : string = this.i + 'VehicleRepairedCv';
    Injuries : string = this.i + 'Injuries';
    OOPClaimExpense : string = this.i + 'OOPClaimExpense';
    InsurancePaidPDLTInsuredVehicle : string = this.i + 'InsurancePaidPDLTInsuredVehicle';
    InsurancePaidPDLTClaimantVehicle : string = this.i + 'InsurancePaidPDLTClaimantVehicle';
    OtherVehiclesInvolved : string = this.i + 'OtherVehiclesInvolved';
    IsDot : string = this.i + 'IsDot';
    AccidentDescription : string = this.i + 'AccidentDescription';
    AttachmentId : string = this.i + 'AttachmentId';
    ClaimNumber : string = this.i + 'ClaimNumber';
    ClaimStatusCv : string = this.i + 'ClaimStatusCv';
    ClaimInsuranceCompanyCv : string = this.i + 'ClaimInsuranceCompanyCv';
    ClaimInsuranceCompanyText : string = this.i + 'ClaimInsuranceCompanyText';
    AdvisorName : string = this.i + 'AdvisorName';
    AdvisorPhone : string = this.i + 'AdvisorPhone';
    ClaimFiledDate : string = this.i + 'ClaimFiledDate';
    ClaimComments : string = this.i + 'ClaimComments';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    SharepointMigrationId : string = this.i + 'SharepointMigrationId';
    AccidentDateMonth : string = this.i + 'AccidentDateMonth';
    StateDisplay : string = this.i + 'StateDisplay';
    IsPoliceReportObtained : string = this.i + 'IsPoliceReportObtained';
    ClaimNumberThirdParty : string = this.i + 'ClaimNumberThirdParty';

    Relations = {
    };
}

export class RoWorkplaceAccidentMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roWorkplaceAccident.';

    constructor() {
        this.ItemDetail.ItemId=2641;
        this.ItemDetail.ItemName='roWorkplaceAccident';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CombinedEmployeeName : string = this.i + 'CombinedEmployeeName';
    CombinedDepartmentName : string = this.i + 'CombinedDepartmentName';
    WorkplaceAccidentId : string = this.i + 'WorkplaceAccidentId';
    IsWachterEmployee : string = this.i + 'IsWachterEmployee';
    EthosUserId : string = this.i + 'Ethos_UserId';
    EmployeeName : string = this.i + 'EmployeeName';
    DepartmentId : string = this.i + 'DepartmentId';
    JobNumberId : string = this.i + 'JobNumberId';
    WJID : string = this.i + 'WJID';
    Facility : string = this.i + 'Facility';
    WorksiteTypeCv : string = this.i + 'WorksiteTypeCv';
    PriorToAccidentDescription : string = this.i + 'PriorToAccidentDescription';
    AccidentDescription : string = this.i + 'AccidentDescription';
    InjuryDescription : string = this.i + 'InjuryDescription';
    ObjectDescription : string = this.i + 'ObjectDescription';
    DeathDescription : string = this.i + 'DeathDescription';
    AttachmentId : string = this.i + 'AttachmentId';
    AccidentTypeCv : string = this.i + 'AccidentTypeCv';
    AccidentDateTime : string = this.i + 'AccidentDateTime';
    BodySideCv : string = this.i + 'BodySideCv';
    BodyPartCv : string = this.i + 'BodyPartCv';
    InjuryTypeCv : string = this.i + 'InjuryTypeCv';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    AccidentAddress : string = this.i + 'AccidentAddress';
    MediaGroupId : string = this.i + 'MediaGroupId';
    InjuryOtherExplanation : string = this.i + 'InjuryOtherExplanation';
    EmployeeAddress : string = this.i + 'EmployeeAddress';
    EmployeeCity : string = this.i + 'EmployeeCity';
    EmployeeState : string = this.i + 'EmployeeState';
    EmployeeZip : string = this.i + 'EmployeeZip';
    AccidentCity : string = this.i + 'AccidentCity';
    AccidentState : string = this.i + 'AccidentState';
    AccidentZip : string = this.i + 'AccidentZip';
    FatalityInvolved : string = this.i + 'FatalityInvolved';
    FatalityDateTime : string = this.i + 'FatalityDateTime';
    ClaimNumber : string = this.i + 'ClaimNumber';
    ClaimFileDate : string = this.i + 'ClaimFileDate';
    ClaimInsuranceCompany : string = this.i + 'ClaimInsuranceCompany';
    ClaimAdjustorName : string = this.i + 'ClaimAdjustorName';
    ClaimAdjustorPhone : string = this.i + 'ClaimAdjustorPhone';
    ClaimComments : string = this.i + 'ClaimComments';
    EmployeeOnLeave : string = this.i + 'EmployeeOnLeave';
    EmployeeHasAttorney : string = this.i + 'EmployeeHasAttorney';
    EmployeeAttorneyName : string = this.i + 'EmployeeAttorneyName';
    EmployeeAttorneyPhone : string = this.i + 'EmployeeAttorneyPhone';
    ClaimStatusCv : string = this.i + 'ClaimStatusCv';
    MedicalWachter : string = this.i + 'MedicalWachter';
    MedicalAboveDeductible : string = this.i + 'MedicalAboveDeductible';
    WageExpenseWachter : string = this.i + 'WageExpenseWachter';
    WageExpenseAboveDeductible : string = this.i + 'WageExpenseAboveDeductible';
    InHouseClaim : string = this.i + 'InHouseClaim';
    WorkersCompAttachmentId : string = this.i + 'WorkersCompAttachmentId';

    Relations = {
            /** Relation: Workplace Accident */
            WorkplaceAccident : {
                RelationName: 'WorkplaceAccident_roWorkplaceAccident',
                FieldPrefix: 'WorkplaceAccident',
                PropertyName: 'WorkplaceAccident'
            },
    };
}

export class RoWorkplaceAccidentNotesMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roWorkplaceAccidentNotes.';

    constructor() {
        this.ItemDetail.ItemId=3414;
        this.ItemDetail.ItemName='roWorkplaceAccidentNotes';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WorkplaceAccidentId : string = this.i + 'WorkplaceAccidentId';
    Notes : string = this.i + 'Notes';
    OOP : string = this.i + 'OOP';

    Relations = {
            /** Relation: Workplace Accident */
            WorkplaceAccident : {
                RelationName: 'WorkplaceAccident_roWorkplaceAccident_WithNote',
                FieldPrefix: 'WorkplaceAccident',
                PropertyName: 'WorkplaceAccident'
            },
    };
}

export class VehicleMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Vehicle.';

    constructor() {
        this.ItemDetail.ItemId=2512;
        this.ItemDetail.ItemName='Vehicle';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    VehicleId : string = this.i + 'VehicleId';
    VehicleAccidentId : string = this.i + 'VehicleAccidentId';
    Year : string = this.i + 'Year';
    Make : string = this.i + 'Make';
    Model : string = this.i + 'Model';
    LicensePlateNumber : string = this.i + 'LicensePlateNumber';
    LicensePlateState : string = this.i + 'LicensePlateState';
    DriverName : string = this.i + 'DriverName';
    DriverLicenseNumber : string = this.i + 'DriverLicenseNumber';
    DriverLicenseState : string = this.i + 'DriverLicenseState';
    DriverPhoneNumber : string = this.i + 'DriverPhoneNumber';
    DriverStreetAddress : string = this.i + 'DriverStreetAddress';
    DriverCity : string = this.i + 'DriverCity';
    DriverState : string = this.i + 'DriverState';
    DriverZip : string = this.i + 'DriverZip';
    InsuranceCompany : string = this.i + 'InsuranceCompany';
    PolicyNumber : string = this.i + 'PolicyNumber';
    DescriptionOfDamage : string = this.i + 'DescriptionOfDamage';
    PassengerName : string = this.i + 'PassengerName';
    PassengerAddress : string = this.i + 'PassengerAddress';
    PassengerPhone : string = this.i + 'PassengerPhone';
    VIN : string = this.i + 'VIN';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    UnitNumber : string = this.i + 'UnitNumber';
    RentalCompanyName : string = this.i + 'RentalCompanyName';
    JurCovGarState : string = this.i + 'JurCovGarState';

    Relations = {
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|Vehicle|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Createdby Ethos User */
            EthosUserByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|Vehicle|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosEthosUser',
                PropertyName: 'CreatedbyEthosEthosUser'
            },
            /** Relation: Vehicle Accident */
            VehicleAccident : {
                RelationName: 'VehicleAccident|Vehicle|VehicleAccidentId',
                FieldPrefix: 'VehicleAccident',
                PropertyName: 'VehicleAccident'
            },
    };
}

export class VehicleAccidentMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'VehicleAccident.';

    constructor() {
        this.ItemDetail.ItemId=2510;
        this.ItemDetail.ItemName='VehicleAccident';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    VehicleAccidentId : string = this.i + 'VehicleAccidentId';
    EmployeeId : string = this.i + 'EmployeeId';
    PhoneNumber : string = this.i + 'PhoneNumber';
    WJID : string = this.i + 'WJID';
    AccidentDateTime : string = this.i + 'AccidentDateTime';
    AuthorityContacted : string = this.i + 'AuthorityContacted';
    ReportNumber : string = this.i + 'ReportNumber';
    DriverStreetAddress : string = this.i + 'DriverStreetAddress';
    DriverCity : string = this.i + 'DriverCity';
    DriverState : string = this.i + 'DriverState';
    DriverZip : string = this.i + 'DriverZip';
    AccidentAddress : string = this.i + 'AccidentAddress';
    AccidentCity : string = this.i + 'AccidentCity';
    AccidentState : string = this.i + 'AccidentState';
    AccidentZip : string = this.i + 'AccidentZip';
    AccidentTypeCv : string = this.i + 'AccidentTypeCv';
    AccidentAtFaultCv : string = this.i + 'AccidentAtFaultCv';
    VehicleRepairedCv : string = this.i + 'VehicleRepairedCv';
    Injuries : string = this.i + 'Injuries';
    OOPClaimExpense : string = this.i + 'OOPClaimExpense';
    InsurancePaidPDLTInsuredVehicle : string = this.i + 'InsurancePaidPDLTInsuredVehicle';
    InsurancePaidPDLTClaimantVehicle : string = this.i + 'InsurancePaidPDLTClaimantVehicle';
    OtherVehiclesInvolved : string = this.i + 'OtherVehiclesInvolved';
    IsDot : string = this.i + 'IsDot';
    AccidentDescription : string = this.i + 'AccidentDescription';
    AttachmentId : string = this.i + 'AttachmentId';
    ClaimNumber : string = this.i + 'ClaimNumber';
    ClaimStatusCv : string = this.i + 'ClaimStatusCv';
    ClaimInsuranceCompanyCv : string = this.i + 'ClaimInsuranceCompanyCv';
    ClaimInsuranceCompanyText : string = this.i + 'ClaimInsuranceCompanyText';
    AdvisorName : string = this.i + 'AdvisorName';
    AdvisorPhone : string = this.i + 'AdvisorPhone';
    ClaimFiledDate : string = this.i + 'ClaimFiledDate';
    ClaimComments : string = this.i + 'ClaimComments';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    SharepointMigrationId : string = this.i + 'SharepointMigrationId';
    IsPoliceReportObtained : string = this.i + 'IsPoliceReportObtained';
    ClaimNumberThirdParty : string = this.i + 'ClaimNumberThirdParty';
    MediaGroupId : string = this.i + 'MediaGroupId';
    VehicleValue : string = this.i + 'VehicleValue';
    SettlementExpense : string = this.i + 'SettlementExpense';
    InsuredVehiclePDLT : string = this.i + 'InsuredVehiclePDLT';
    ClaimantVehiclePDLT : string = this.i + 'ClaimantVehiclePDLT';
    InsuredObtainedRentalExpense : string = this.i + 'InsuredObtainedRentalExpense';
    ClaimantObtainedRentalExpense : string = this.i + 'ClaimantObtainedRentalExpense';
    StorageTowingFees : string = this.i + 'StorageTowingFees';
    PoliceReportMiscFees : string = this.i + 'PoliceReportMiscFees';
    ClaimHandlingFee : string = this.i + 'ClaimHandlingFee';
    EstimatedCosts : string = this.i + 'EstimatedCosts';
    Recoveries : string = this.i + 'Recoveries';
    Version : string = this.i + 'Version';
    ReportDateTime : string = this.i + 'ReportDateTime';
    ContractEffDate : string = this.i + 'ContractEffDate';
    CloseDate : string = this.i + 'CloseDate';
    ReopenDate : string = this.i + 'ReopenDate';
    ClaimantDriverName : string = this.i + 'ClaimantDriverName';
    LineOfBusinessCv : string = this.i + 'LineOfBusinessCv';
    PhysicalDamagePaidExpense : string = this.i + 'PhysicalDamagePaidExpense';
    PhysicalDamagePaidPd : string = this.i + 'PhysicalDamagePaidPd';
    PhysicalDamageOsReserveExp : string = this.i + 'PhysicalDamageOsReserveExp';
    PhysicalDamageOsReservePd : string = this.i + 'PhysicalDamageOsReservePd';
    PhysicalDamageTotalRecovery : string = this.i + 'PhysicalDamageTotalRecovery';
    LiabilityPaidExpense : string = this.i + 'LiabilityPaidExpense';
    LiabilityPaidIndBlMed : string = this.i + 'LiabilityPaidIndBlMed';
    LiabilityPaidIndPdLt : string = this.i + 'LiabilityPaidIndPdLt';
    LiabilityOsReserveExp : string = this.i + 'LiabilityOsReserveExp';
    LiabilityOsReserveBlMed : string = this.i + 'LiabilityOsReserveBlMed';
    LiabilityOsReservePdLt : string = this.i + 'LiabilityOsReservePdLt';
    LiabilityTotalRecovery : string = this.i + 'LiabilityTotalRecovery';

    Relations = {
            /** Relation: Trust Code Value - Accident At Fault */
            CodeValueByAccidentAtFaultCv : {
                RelationName: 'CodeValue|VehicleAccident|AccidentAtFaultCv',
                FieldPrefix: 'AccidentAtFaultCvCodeValue',
                PropertyName: 'AccidentAtFaultCvCodeValue'
            },
            /** Relation: Trust Code Value - Accident Type */
            CodeValueByAccidentTypeCv : {
                RelationName: 'CodeValue|VehicleAccident|AccidentTypeCv',
                FieldPrefix: 'AccidentTypeCvCodeValue',
                PropertyName: 'AccidentTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Claim Insurance Company */
            CodeValueByClaimInsuranceCompanyCv : {
                RelationName: 'CodeValue|VehicleAccident|ClaimInsuranceCompanyCv',
                FieldPrefix: 'ClaimInsuranceCompanyCvCodeValue',
                PropertyName: 'ClaimInsuranceCompanyCvCodeValue'
            },
            /** Relation: Trust Code Value - Claim Status */
            CodeValueByClaimStatusCv : {
                RelationName: 'CodeValue|VehicleAccident|ClaimStatusCv',
                FieldPrefix: 'ClaimStatusCvCodeValue',
                PropertyName: 'ClaimStatusCvCodeValue'
            },
            /** Relation: Trust Code Value - Vehicle Repaired */
            CodeValueByVehicleRepairedCv : {
                RelationName: 'CodeValue|VehicleAccident|VehicleRepairedCv',
                FieldPrefix: 'VehicleRepairedCvCodeValue',
                PropertyName: 'VehicleRepairedCvCodeValue'
            },
            /** Relation: Trust Code Value - Line Of Business */
            CodeValueByLineOfBusinessCv : {
                RelationName: 'CodeValue|VehicleAccident|LineOfBusinessCv',
                FieldPrefix: 'LineOfBusinessCvCodeValue',
                PropertyName: 'LineOfBusinessCvCodeValue'
            },
            /** Relation: Ro Ethos User - Employee */
            RoEthosUserByEmployeeId : {
                RelationName: 'VehicleAccident|roEthos_User|UserId',
                FieldPrefix: 'EmployeeIdRoEthosUser',
                PropertyName: 'EmployeeIdRoEthosUser'
            },
            /** Relation: Ro Ethos User - Createdby Ethos User */
            RoEthosUserByCreatedbyEthosUserId : {
                RelationName: 'VehicleAccident|roEthos_User|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedbyEthosRoEthosUser',
                PropertyName: 'CreatedbyEthosRoEthosUser'
            },
            /** Relation: Ro Ethos User - Modified By Ethos User */
            RoEthosUserByModifiedByEthosUserId : {
                RelationName: 'VehicleAccident|roEthos_User|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosRoEthosUser',
                PropertyName: 'ModifiedByEthosRoEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|VehicleAccident|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Createdby Ethos User */
            EthosUserByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|VehicleAccident|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosEthosUser',
                PropertyName: 'CreatedbyEthosEthosUser'
            },
            /** Relation: Vehicle */
            Vehicle : {
                RelationName: 'VehicleAccident|Vehicle|VehicleAccidentId',
                FieldPrefix: 'Vehicle',
                PropertyName: 'Vehicle'
            },
    };
}

export class WageExpenseMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'WageExpense.';

    constructor() {
        this.ItemDetail.ItemId=3412;
        this.ItemDetail.ItemName='WageExpense';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WageExpenseId : string = this.i + 'WageExpenseId';
    WorkplaceAccidentId : string = this.i + 'WorkplaceAccidentId';
    Details : string = this.i + 'Details';
    PaidDateTime : string = this.i + 'PaidDateTime';
    Wages : string = this.i + 'Wages';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';

    Relations = {
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|WageExpense|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|WageExpense|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Workplace Accident */
            WorkplaceAccident : {
                RelationName: 'WorkplaceAccident|WageExpense|WorkplaceAccidentId',
                FieldPrefix: 'WorkplaceAccident',
                PropertyName: 'WorkplaceAccident'
            },
    };
}

export class WorkplaceAccidentMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'workplaceAccident.';

    constructor() {
        this.ItemDetail.ItemId=2592;
        this.ItemDetail.ItemName='workplaceAccident';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WorkplaceAccidentId : string = this.i + 'WorkplaceAccidentId';
    IsWachterEmployee : string = this.i + 'IsWachterEmployee';
    EthosUserId : string = this.i + 'Ethos_UserId';
    EmployeeName : string = this.i + 'EmployeeName';
    DepartmentId : string = this.i + 'DepartmentId';
    JobNumberId : string = this.i + 'JobNumberId';
    WJID : string = this.i + 'WJID';
    Facility : string = this.i + 'Facility';
    WorksiteTypeCv : string = this.i + 'WorksiteTypeCv';
    PriorToAccidentDescription : string = this.i + 'PriorToAccidentDescription';
    AccidentDescription : string = this.i + 'AccidentDescription';
    InjuryDescription : string = this.i + 'InjuryDescription';
    DeathDescription : string = this.i + 'DeathDescription';
    AttachmentId : string = this.i + 'AttachmentId';
    ObjectDescription : string = this.i + 'ObjectDescription';
    AccidentTypeCv : string = this.i + 'AccidentTypeCv';
    AccidentDateTime : string = this.i + 'AccidentDateTime';
    BodySideCv : string = this.i + 'BodySideCv';
    BodyPartCv : string = this.i + 'BodyPartCv';
    InjuryTypeCv : string = this.i + 'InjuryTypeCv';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    MediaGroupId : string = this.i + 'MediaGroupId';
    InjuryOtherExplanation : string = this.i + 'InjuryOtherExplanation';
    EmployeeAddress : string = this.i + 'EmployeeAddress';
    AccidentAddress : string = this.i + 'AccidentAddress';
    EmployeeCity : string = this.i + 'EmployeeCity';
    EmployeeState : string = this.i + 'EmployeeState';
    EmployeeZip : string = this.i + 'EmployeeZip';
    AccidentCity : string = this.i + 'AccidentCity';
    AccidentState : string = this.i + 'AccidentState';
    AccidentZip : string = this.i + 'AccidentZip';
    FatalityInvolved : string = this.i + 'FatalityInvolved';
    FatalityDateTime : string = this.i + 'FatalityDateTime';
    ClaimNumber : string = this.i + 'ClaimNumber';
    ClaimFileDate : string = this.i + 'ClaimFileDate';
    ClaimInsuranceCompany : string = this.i + 'ClaimInsuranceCompany';
    ClaimAdjustorName : string = this.i + 'ClaimAdjustorName';
    ClaimAdjustorPhone : string = this.i + 'ClaimAdjustorPhone';
    ClaimComments : string = this.i + 'ClaimComments';
    EmployeeOnLeave : string = this.i + 'EmployeeOnLeave';
    EmployeeHasAttorney : string = this.i + 'EmployeeHasAttorney';
    EmployeeAttorneyName : string = this.i + 'EmployeeAttorneyName';
    EmployeeAttorneyPhone : string = this.i + 'EmployeeAttorneyPhone';
    ClaimStatusCv : string = this.i + 'ClaimStatusCv';
    MedicalWachter : string = this.i + 'MedicalWachter';
    MedicalAboveDeductible : string = this.i + 'MedicalAboveDeductible';
    WageExpenseWachter : string = this.i + 'WageExpenseWachter';
    WageExpenseAboveDeductible : string = this.i + 'WageExpenseAboveDeductible';
    WorkersCompAttachmentId : string = this.i + 'WorkersCompAttachmentId';
    WorkersCompNoteParentId : string = this.i + 'WorkersCompNoteParentId';
    NoteParentId : string = this.i + 'NoteParentId';
    InHouseClaimNumber : string = this.i + 'InHouseClaimNumber';
    InHouseClaimFileDate : string = this.i + 'InHouseClaimFileDate';
    InHouseClaimStatusCv : string = this.i + 'InHouseClaimStatusCv';
    EmployeePhone : string = this.i + 'EmployeePhone';

    Relations = {
            /** Relation: Trust Code Value - Injury Type */
            CodeValueByInjuryTypeCv : {
                RelationName: 'CodeValue|workplaceAccident|InjuryTypeCv',
                FieldPrefix: 'InjuryTypeCvCodeValue',
                PropertyName: 'InjuryTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Accident Type */
            CodeValueByAccidentTypeCv : {
                RelationName: 'CodeValue|workplaceAccident|AccidentTypeCv',
                FieldPrefix: 'AccidentTypeCvCodeValue',
                PropertyName: 'AccidentTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Body Part */
            CodeValueByBodyPartCv : {
                RelationName: 'CodeValue|workplaceAccident|BodyPartCv',
                FieldPrefix: 'BodyPartCvCodeValue',
                PropertyName: 'BodyPartCvCodeValue'
            },
            /** Relation: Trust Code Value - Body Side */
            CodeValueByBodySideCv : {
                RelationName: 'CodeValue|workplaceAccident|BodySideCv',
                FieldPrefix: 'BodySideCvCodeValue',
                PropertyName: 'BodySideCvCodeValue'
            },
            /** Relation: Trust Code Value - Worksite Type */
            CodeValueByWorksiteTypeCv : {
                RelationName: 'CodeValue|workplaceAccident|WorksiteTypeCv',
                FieldPrefix: 'WorksiteTypeCvCodeValue',
                PropertyName: 'WorksiteTypeCvCodeValue'
            },
            /** Relation: Trust Code Value - Claim Status */
            CodeValueByClaimStatusCv : {
                RelationName: 'CodeValue|workplaceAccident|ClaimStatusCv',
                FieldPrefix: 'ClaimStatusCvCodeValue',
                PropertyName: 'ClaimStatusCvCodeValue'
            },
            /** Relation: Trust Code Value - In House Claim Status */
            CodeValueByInHouseClaimStatusCv : {
                RelationName: 'CodeValue|workplaceAccident|InHouseClaimStatusCv',
                FieldPrefix: 'InHouseClaimStatusCvCodeValue',
                PropertyName: 'InHouseClaimStatusCvCodeValue'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|workplaceAccident|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Createdby Ethos User */
            EthosUserByCreatedbyEthosUserId : {
                RelationName: 'Ethos_User|workplaceAccident|CreatedbyEthos_UserId',
                FieldPrefix: 'CreatedbyEthosEthosUser',
                PropertyName: 'CreatedbyEthosEthosUser'
            },
            /** Relation: Ethos User - User */
            EthosUserByEthosUserId : {
                RelationName: 'Ethos_User|workplaceAccident|Ethos_UserId',
                FieldPrefix: 'EthosEthosUser',
                PropertyName: 'EthosEthosUser'
            },
            /** Relation: Wachter Department - Department */
            EthosWachterDepartmentByDepartmentId : {
                RelationName: 'Ethos_WachterDepartment|workplaceAccident|DepartmentId',
                FieldPrefix: 'DepartmentIdEthosWachterDepartment',
                PropertyName: 'DepartmentIdEthosWachterDepartment'
            },
            /** Relation: Medical Record */
            MedicalRecord : {
                RelationName: 'WorkplaceAccident|MedicalRecord|WorkplaceAccidentId',
                FieldPrefix: 'MedicalRecord',
                PropertyName: 'MedicalRecord'
            },
            /** Relation: Ro Workplace Accident */
            RoWorkplaceAccident : {
                RelationName: 'WorkplaceAccident_roWorkplaceAccident',
                FieldPrefix: 'RoWorkplaceAccident',
                PropertyName: 'RoWorkplaceAccident'
            },
            /** Relation: Ro Workplace Accident Notes */
            RoWorkplaceAccidentNotes : {
                RelationName: 'WorkplaceAccident_roWorkplaceAccident_WithNote',
                FieldPrefix: 'RoWorkplaceAccidentNotes',
                PropertyName: 'RoWorkplaceAccidentNotes'
            },
            /** Relation: Wage Expense */
            WageExpense : {
                RelationName: 'WorkplaceAccident|WageExpense|WorkplaceAccidentId',
                FieldPrefix: 'WageExpense',
                PropertyName: 'WageExpense'
            },
    };
}

export class AccidentsMetaData {

    static CodeValue : CodeValueMetaData = new CodeValueMetaData();
    static EthosCodeValue : EthosCodeValueMetaData = new EthosCodeValueMetaData();
    static EthosCodeValueCustom : EthosCodeValueCustomMetaData = new EthosCodeValueCustomMetaData();
    static EthosUser : EthosUserMetaData = new EthosUserMetaData();
    static EthosUserDiff : EthosUserDiffMetaData = new EthosUserDiffMetaData();
    static EthosUserSkill : EthosUserSkillMetaData = new EthosUserSkillMetaData();
    static EthosWachterDepartment : EthosWachterDepartmentMetaData = new EthosWachterDepartmentMetaData();
    static MedicalRecord : MedicalRecordMetaData = new MedicalRecordMetaData();
    static RoEthosUser : RoEthosUserMetaData = new RoEthosUserMetaData();
    static RoEthosUserOriginal : RoEthosUserOriginalMetaData = new RoEthosUserOriginalMetaData();
    static RoVehicleAccidents : RoVehicleAccidentsMetaData = new RoVehicleAccidentsMetaData();
    static RoWorkplaceAccident : RoWorkplaceAccidentMetaData = new RoWorkplaceAccidentMetaData();
    static RoWorkplaceAccidentNotes : RoWorkplaceAccidentNotesMetaData = new RoWorkplaceAccidentNotesMetaData();
    static Vehicle : VehicleMetaData = new VehicleMetaData();
    static VehicleAccident : VehicleAccidentMetaData = new VehicleAccidentMetaData();
    static WageExpense : WageExpenseMetaData = new WageExpenseMetaData();
    static WorkplaceAccident : WorkplaceAccidentMetaData = new WorkplaceAccidentMetaData();
}
// Generated Entity Interfaces
export interface CodeValueEntity extends DwOrmData {
    // Attributes
    CodeValueId?: number;
    CodeSetId?: number;
    Display?: string;
    Meaning?: string;
    Description?: string;
    CodeValueOrder?: number;
    IsActive?: boolean;

    // Display Attributes
    CodeSetIdDisplay?: string;

    // Relations
    AccidentAtFaultCvVehicleAccident? : VehicleAccidentEntity[];
    AccidentTypeCvVehicleAccident? : VehicleAccidentEntity[];
    ClaimInsuranceCompanyCvVehicleAccident? : VehicleAccidentEntity[];
    ClaimStatusCvVehicleAccident? : VehicleAccidentEntity[];
    VehicleRepairedCvVehicleAccident? : VehicleAccidentEntity[];
    LineOfBusinessCvVehicleAccident? : VehicleAccidentEntity[];
    InjuryTypeCvWorkplaceAccident? : WorkplaceAccidentEntity[];
    AccidentTypeCvWorkplaceAccident? : WorkplaceAccidentEntity[];
    BodyPartCvWorkplaceAccident? : WorkplaceAccidentEntity[];
    BodySideCvWorkplaceAccident? : WorkplaceAccidentEntity[];
    WorksiteTypeCvWorkplaceAccident? : WorkplaceAccidentEntity[];
    ClaimStatusCvWorkplaceAccident? : WorkplaceAccidentEntity[];
    InHouseClaimStatusCvWorkplaceAccident? : WorkplaceAccidentEntity[];
}

export interface EthosCodeValueEntity extends DwOrmData {
    // Attributes
    CodeValueId?: number;
    CodeSetId?: number;
    Display?: string;
    Meaning?: string;
    Description?: string;
    CodeValueOrder?: number;
    IsActive?: boolean;
    ImagePath?: string;

    // Display Attributes
    CodeSetIdDisplay?: string;

    // Relations
    UserTypeCvEthosUser? : EthosUserEntity[];
    // Duplicate property excluded
    // UserTypeCvEthosUser : EthosUserEntity[];
    ResourceGroupCvEthosUser? : EthosUserEntity[];
    SkillCvEthosUserSkill? : EthosUserSkillEntity[];
    DepartmentTypeCvEthosWachterDepartment? : EthosWachterDepartmentEntity[];
    ResourceGroupCvRoEthosUser? : RoEthosUserEntity[];
    UserTypeCvRoEthosUser? : RoEthosUserEntity[];
}

export interface EthosCodeValueCustomEntity extends DwOrmData {
    // Attributes
    CodeValueCustomId?: number;
    CodeSetId?: number;
    Display?: string;
    Meaning?: string;
    Description?: string;
    CodeValueOrder?: number;
    IsActive?: boolean;

    // Display Attributes
    CodeSetIdDisplay?: string;

    // Relations
}

export interface EthosUserEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceShortName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    RowInsertDateTime?: string;
    EmployeeType?: string;
    StateProvinceId?: number;
    PictureAttachmentFileKey?: string;
    CustomerId?: number;
    SubcontractorId?: number;
    SpecialInstructions?: string;
    isVaxxed?: boolean;

    // Display Attributes
    UserIdDisplay?: string;
    WachterJobTitleIdDisplay?: string;
    UserTypeCvDisplay?: string;
    StaffingAgencyIdDisplay?: string;
    ResourceGroupCvDisplay?: string;
    WachterTeamIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    SupervisorUserIdDisplay?: string;
    UserStatusWsDisplay?: string;
    StateProvinceIdDisplay?: string;
    CustomerIdDisplay?: string;

    // Relations
    UserTypeCvEthosCodeValue? : EthosCodeValueEntity;
    // Duplicate property excluded
    // UserTypeCvEthosCodeValue : EthosCodeValueEntity;
    ResourceGroupCvEthosCodeValue? : EthosCodeValueEntity;
    SupervisorEthosUser? : EthosUserEntity;
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity;
    EthosWachterDepartment? : EthosWachterDepartmentEntity[];
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity[];
    EthosEthosUserDiff? : EthosUserDiffEntity[];
    EthosUserSkill? : EthosUserSkillEntity[];
    DepartmentDirectorEthosWachterDepartment? : EthosWachterDepartmentEntity[];
    DepartmentManagerEthosWachterDepartment? : EthosWachterDepartmentEntity[];
    DepartmentAsstManagerEthosWachterDepartment? : EthosWachterDepartmentEntity[];
    CreatedByEthosMedicalRecord? : MedicalRecordEntity[];
    ModifiedByEthosMedicalRecord? : MedicalRecordEntity[];
    RoEthosUser? : RoEthosUserEntity;
    SupervisorRoEthosUser? : RoEthosUserEntity[];
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity[];
    ModifiedByEthosVehicle? : VehicleEntity[];
    CreatedbyEthosVehicle? : VehicleEntity[];
    ModifiedByEthosVehicleAccident? : VehicleAccidentEntity[];
    CreatedbyEthosVehicleAccident? : VehicleAccidentEntity[];
    CreatedByEthosWageExpense? : WageExpenseEntity[];
    ModifiedByEthosWageExpense? : WageExpenseEntity[];
    ModifiedByEthosWorkplaceAccident? : WorkplaceAccidentEntity[];
    CreatedbyEthosWorkplaceAccident? : WorkplaceAccidentEntity[];
    EthosWorkplaceAccident? : WorkplaceAccidentEntity[];
}

export interface EthosUserDiffEntity extends DwOrmData {
    // Attributes
    Ethos_UserDiffId?: number;
    Ethos_UserId?: number;
    FieldName?: string;
    OldValue?: string;
    NewValue?: string;
    ChangedDateTime?: string;

    // Display Attributes
    Ethos_UserIdDisplay?: string;

    // Relations
    EthosEthosUser? : EthosUserEntity;
}

export interface EthosUserSkillEntity extends DwOrmData {
    // Attributes
    UserSkillId?: number;
    UserId?: number;
    SkillCv?: number;
    Meaning?: string;
    Display?: string;

    // Display Attributes
    UserIdDisplay?: string;
    SkillCvDisplay?: string;

    // Relations
    SkillCvEthosCodeValue? : EthosCodeValueEntity;
    EthosUser? : EthosUserEntity;
}

export interface EthosWachterDepartmentEntity extends DwOrmData {
    // Attributes
    WachterDepartmentId?: number;
    DepartmentTypeCv?: number;
    DepartmentTypeMeaning?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    DepartmentDirectorUserId?: number;
    IsDeleted?: boolean;
    DepartmentManagerUserId?: number;
    DepartmentAsstManagerUserId?: number;
    JobNumberId?: number;
    AxIntegrationId?: string;
    JobNumberPhaseId?: number;
    RowInsertDateTime?: string;

    // Display Attributes
    DepartmentTypeCvDisplay?: string;
    DepartmentDirectorUserIdDisplay?: string;
    DepartmentManagerUserIdDisplay?: string;
    DepartmentAsstManagerUserIdDisplay?: string;
    JobNumberIdDisplay?: string;
    JobNumberPhaseIdDisplay?: string;

    // Relations
    DepartmentTypeCvEthosCodeValue? : EthosCodeValueEntity;
    DepartmentDirectorEthosUser? : EthosUserEntity;
    DepartmentManagerEthosUser? : EthosUserEntity;
    DepartmentAsstManagerEthosUser? : EthosUserEntity;
    EthosUser? : EthosUserEntity;
    RoEthosUser? : RoEthosUserEntity[];
    DepartmentIdWorkplaceAccident? : WorkplaceAccidentEntity[];
}

export interface MedicalRecordEntity extends DwOrmData {
    // Attributes
    MedicalRecordId?: number;
    WorkplaceAccidentId?: number;
    Details?: string;
    TreatmentDateTime?: string;
    Cost?: number;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;

    // Display Attributes
    WorkplaceAccidentIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    CreatedByEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    WorkplaceAccident? : WorkplaceAccidentEntity;
}

export interface RoEthosUserEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceShortName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    RowInsertDateTime?: string;
    TeamName?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    NameLastFirst?: string;
    NameLastPrefered?: string;
    NameLastFirstPrefered?: string;
    NameFirstLast?: string;
    NamePreferedLast?: string;
    NameFirstPreferedLast?: string;
    NameFirstMiddleLast?: string;
    NamePreferedMidInitialLast?: string;
    NameLastFirstPreferedStatus?: string;
    EmployeeType?: string;
    StateProvinceId?: number;
    PictureAttachmentFileKey?: string;
    NameLastFirstPreferedType?: string;
    IsActive?: number;
    SpecialInstructions?: string;
    BirthMonthDate?: string;
    TerritoryId?: number;
    TerritoryName?: string;
    Company?: string;
    LicenseCount?: number;
    AXId?: string;
    YrsService?: number;
    StaffingAgencyName?: string;

    // Display Attributes
    UserIdDisplay?: string;
    WachterJobTitleIdDisplay?: string;
    UserTypeCvDisplay?: string;
    StaffingAgencyIdDisplay?: string;
    ResourceGroupCvDisplay?: string;
    WachterTeamIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    SupervisorUserIdDisplay?: string;
    UserStatusWsDisplay?: string;
    StateProvinceIdDisplay?: string;
    TerritoryIdDisplay?: string;

    // Relations
    ResourceGroupCvEthosCodeValue? : EthosCodeValueEntity;
    UserTypeCvEthosCodeValue? : EthosCodeValueEntity;
    SupervisorRoEthosUser? : RoEthosUserEntity;
    EthosUser? : EthosUserEntity;
    SupervisorEthosUser? : EthosUserEntity;
    EthosWachterDepartment? : EthosWachterDepartmentEntity;
    // Duplicate property excluded
    // SupervisorRoEthosUser : RoEthosUserEntity[];
    EmployeeIdVehicleAccident? : VehicleAccidentEntity;
    CreatedbyEthosVehicleAccident? : VehicleAccidentEntity[];
    ModifiedByEthosVehicleAccident? : VehicleAccidentEntity[];
    // Duplicate property excluded
    // EmployeeIdVehicleAccident : VehicleAccidentEntity[];
}

export interface RoEthosUserOriginalEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    AXId?: string;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    EmployeeType?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    BirthMonthDate?: string;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsActive?: number;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentFileKey?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceId?: number;
    StateProvinceShortName?: string;
    TerritoryId?: number;
    TerritoryName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    SpecialInstructions?: string;
    RowInsertDateTime?: string;
    TeamName?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    Company?: number;
    LicenseCount?: number;
    NameLastFirst?: string;
    NameLastPrefered?: string;
    NameLastFirstPrefered?: string;
    NameFirstLast?: string;
    NamePreferedLast?: string;
    NameFirstPreferedLast?: string;
    NameFirstMiddleLast?: string;
    NamePreferedMidInitialLast?: string;
    NameLastFirstPreferedStatus?: string;
    NameLastFirstPreferedType?: string;


    // Relations
}

export interface RoVehicleAccidentsEntity extends DwOrmData {
    // Attributes
    VehicleAccidentId?: number;
    EmployeeId?: number;
    PhoneNumber?: string;
    WJID?: string;
    AccidentDateTime?: string;
    AuthorityContacted?: string;
    ReportNumber?: string;
    DriverStreetAddress?: string;
    DriverCity?: string;
    DriverState?: number;
    DriverZip?: string;
    AccidentAddress?: string;
    AccidentCity?: string;
    AccidentState?: number;
    AccidentZip?: string;
    AccidentTypeCv?: number;
    AccidentAtFaultCv?: number;
    VehicleRepairedCv?: number;
    Injuries?: boolean;
    OOPClaimExpense?: string;
    InsurancePaidPDLTInsuredVehicle?: string;
    InsurancePaidPDLTClaimantVehicle?: string;
    OtherVehiclesInvolved?: boolean;
    IsDot?: boolean;
    AccidentDescription?: string;
    AttachmentId?: number;
    ClaimNumber?: string;
    ClaimStatusCv?: number;
    ClaimInsuranceCompanyCv?: number;
    ClaimInsuranceCompanyText?: string;
    AdvisorName?: string;
    AdvisorPhone?: string;
    ClaimFiledDate?: string;
    ClaimComments?: string;
    CreatedbyEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    SharepointMigrationId?: number;
    AccidentDateMonth?: string;
    StateDisplay?: string;
    IsPoliceReportObtained?: boolean;
    ClaimNumberThirdParty?: string;


    // Relations
}

export interface RoWorkplaceAccidentEntity extends DwOrmData {
    // Attributes
    CombinedEmployeeName?: string;
    CombinedDepartmentName?: string;
    WorkplaceAccidentId?: number;
    IsWachterEmployee?: boolean;
    Ethos_UserId?: number;
    EmployeeName?: string;
    DepartmentId?: number;
    JobNumberId?: number;
    WJID?: string;
    Facility?: string;
    WorksiteTypeCv?: number;
    PriorToAccidentDescription?: string;
    AccidentDescription?: string;
    InjuryDescription?: string;
    ObjectDescription?: string;
    DeathDescription?: string;
    AttachmentId?: number;
    AccidentTypeCv?: number;
    AccidentDateTime?: string;
    BodySideCv?: number;
    BodyPartCv?: number;
    InjuryTypeCv?: number;
    CreatedbyEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    AccidentAddress?: string;
    MediaGroupId?: number;
    InjuryOtherExplanation?: string;
    EmployeeAddress?: string;
    EmployeeCity?: string;
    EmployeeState?: number;
    EmployeeZip?: string;
    AccidentCity?: string;
    AccidentState?: number;
    AccidentZip?: string;
    FatalityInvolved?: boolean;
    FatalityDateTime?: string;
    ClaimNumber?: string;
    ClaimFileDate?: string;
    ClaimInsuranceCompany?: string;
    ClaimAdjustorName?: string;
    ClaimAdjustorPhone?: string;
    ClaimComments?: string;
    EmployeeOnLeave?: boolean;
    EmployeeHasAttorney?: boolean;
    EmployeeAttorneyName?: string;
    EmployeeAttorneyPhone?: string;
    ClaimStatusCv?: number;
    MedicalWachter?: string;
    MedicalAboveDeductible?: string;
    WageExpenseWachter?: string;
    WageExpenseAboveDeductible?: string;
    InHouseClaim?: boolean;
    WorkersCompAttachmentId?: number;

    // Display Attributes
    WorkplaceAccidentIdDisplay?: string;

    // Relations
    WorkplaceAccident? : WorkplaceAccidentEntity;
}

export interface RoWorkplaceAccidentNotesEntity extends DwOrmData {
    // Attributes
    WorkplaceAccidentId?: number;
    Notes?: string;
    OOP?: number;

    // Display Attributes
    WorkplaceAccidentIdDisplay?: string;

    // Relations
    WorkplaceAccident? : WorkplaceAccidentEntity;
}

export interface VehicleEntity extends DwOrmData {
    // Attributes
    VehicleId?: number;
    VehicleAccidentId?: number;
    Year?: number;
    Make?: string;
    Model?: string;
    LicensePlateNumber?: string;
    LicensePlateState?: number;
    DriverName?: string;
    DriverLicenseNumber?: string;
    DriverLicenseState?: number;
    DriverPhoneNumber?: string;
    DriverStreetAddress?: string;
    DriverCity?: string;
    DriverState?: number;
    DriverZip?: string;
    InsuranceCompany?: string;
    PolicyNumber?: string;
    DescriptionOfDamage?: string;
    PassengerName?: string;
    PassengerAddress?: string;
    PassengerPhone?: string;
    VIN?: string;
    CreatedbyEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    UnitNumber?: string;
    RentalCompanyName?: string;
    JurCovGarState?: number;

    // Display Attributes
    VehicleAccidentIdDisplay?: string;
    LicensePlateStateDisplay?: string;
    DriverLicenseStateDisplay?: string;
    DriverStateDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    JurCovGarStateDisplay?: string;

    // Relations
    ModifiedByEthosEthosUser? : EthosUserEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
    VehicleAccident? : VehicleAccidentEntity;
}

export interface VehicleAccidentEntity extends DwOrmData {
    // Attributes
    VehicleAccidentId?: number;
    EmployeeId?: number;
    PhoneNumber?: string;
    WJID?: string;
    AccidentDateTime?: string;
    AuthorityContacted?: string;
    ReportNumber?: string;
    DriverStreetAddress?: string;
    DriverCity?: string;
    DriverState?: number;
    DriverZip?: string;
    AccidentAddress?: string;
    AccidentCity?: string;
    AccidentState?: number;
    AccidentZip?: string;
    AccidentTypeCv?: number;
    AccidentAtFaultCv?: number;
    VehicleRepairedCv?: number;
    Injuries?: boolean;
    OOPClaimExpense?: string;
    InsurancePaidPDLTInsuredVehicle?: string;
    InsurancePaidPDLTClaimantVehicle?: string;
    OtherVehiclesInvolved?: boolean;
    IsDot?: boolean;
    AccidentDescription?: string;
    AttachmentId?: number;
    ClaimNumber?: string;
    ClaimStatusCv?: number;
    ClaimInsuranceCompanyCv?: number;
    ClaimInsuranceCompanyText?: string;
    AdvisorName?: string;
    AdvisorPhone?: string;
    ClaimFiledDate?: string;
    ClaimComments?: string;
    CreatedbyEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    SharepointMigrationId?: number;
    IsPoliceReportObtained?: boolean;
    ClaimNumberThirdParty?: string;
    MediaGroupId?: number;
    VehicleValue?: number;
    SettlementExpense?: number;
    InsuredVehiclePDLT?: string;
    ClaimantVehiclePDLT?: string;
    InsuredObtainedRentalExpense?: string;
    ClaimantObtainedRentalExpense?: string;
    StorageTowingFees?: string;
    PoliceReportMiscFees?: string;
    ClaimHandlingFee?: number;
    EstimatedCosts?: number;
    Recoveries?: string;
    Version?: number;
    ReportDateTime?: string;
    ContractEffDate?: string;
    CloseDate?: string;
    ReopenDate?: string;
    ClaimantDriverName?: string;
    LineOfBusinessCv?: number;
    PhysicalDamagePaidExpense?: number;
    PhysicalDamagePaidPd?: number;
    PhysicalDamageOsReserveExp?: number;
    PhysicalDamageOsReservePd?: number;
    PhysicalDamageTotalRecovery?: number;
    LiabilityPaidExpense?: number;
    LiabilityPaidIndBlMed?: number;
    LiabilityPaidIndPdLt?: number;
    LiabilityOsReserveExp?: number;
    LiabilityOsReserveBlMed?: number;
    LiabilityOsReservePdLt?: number;
    LiabilityTotalRecovery?: number;

    // Display Attributes
    EmployeeIdDisplay?: string;
    DriverStateDisplay?: string;
    AccidentStateDisplay?: string;
    AccidentTypeCvDisplay?: string;
    AccidentAtFaultCvDisplay?: string;
    VehicleRepairedCvDisplay?: string;
    AttachmentIdDisplay?: string;
    ClaimStatusCvDisplay?: string;
    ClaimInsuranceCompanyCvDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    LineOfBusinessCvDisplay?: string;

    // Relations
    AccidentAtFaultCvCodeValue? : CodeValueEntity;
    AccidentTypeCvCodeValue? : CodeValueEntity;
    ClaimInsuranceCompanyCvCodeValue? : CodeValueEntity;
    ClaimStatusCvCodeValue? : CodeValueEntity;
    VehicleRepairedCvCodeValue? : CodeValueEntity;
    LineOfBusinessCvCodeValue? : CodeValueEntity;
    EmployeeIdRoEthosUser? : RoEthosUserEntity[];
    CreatedbyEthosRoEthosUser? : RoEthosUserEntity;
    ModifiedByEthosRoEthosUser? : RoEthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
    // Duplicate property excluded
    // EmployeeIdRoEthosUser : RoEthosUserEntity;
    Vehicle? : VehicleEntity[];
}

export interface WageExpenseEntity extends DwOrmData {
    // Attributes
    WageExpenseId?: number;
    WorkplaceAccidentId?: number;
    Details?: string;
    PaidDateTime?: string;
    Wages?: number;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;

    // Display Attributes
    WorkplaceAccidentIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    CreatedByEthosEthosUser? : EthosUserEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    WorkplaceAccident? : WorkplaceAccidentEntity;
}

export interface WorkplaceAccidentEntity extends DwOrmData {
    // Attributes
    WorkplaceAccidentId?: number;
    IsWachterEmployee?: boolean;
    Ethos_UserId?: number;
    EmployeeName?: string;
    DepartmentId?: number;
    JobNumberId?: number;
    WJID?: string;
    Facility?: string;
    WorksiteTypeCv?: number;
    PriorToAccidentDescription?: string;
    AccidentDescription?: string;
    InjuryDescription?: string;
    DeathDescription?: string;
    AttachmentId?: number;
    ObjectDescription?: string;
    AccidentTypeCv?: number;
    AccidentDateTime?: string;
    BodySideCv?: number;
    BodyPartCv?: number;
    InjuryTypeCv?: number;
    CreatedbyEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    MediaGroupId?: number;
    InjuryOtherExplanation?: string;
    EmployeeAddress?: string;
    AccidentAddress?: string;
    EmployeeCity?: string;
    EmployeeState?: number;
    EmployeeZip?: string;
    AccidentCity?: string;
    AccidentState?: number;
    AccidentZip?: string;
    FatalityInvolved?: boolean;
    FatalityDateTime?: string;
    ClaimNumber?: string;
    ClaimFileDate?: string;
    ClaimInsuranceCompany?: string;
    ClaimAdjustorName?: string;
    ClaimAdjustorPhone?: string;
    ClaimComments?: string;
    EmployeeOnLeave?: boolean;
    EmployeeHasAttorney?: boolean;
    EmployeeAttorneyName?: string;
    EmployeeAttorneyPhone?: string;
    ClaimStatusCv?: number;
    MedicalWachter?: string;
    MedicalAboveDeductible?: string;
    WageExpenseWachter?: string;
    WageExpenseAboveDeductible?: string;
    WorkersCompAttachmentId?: number;
    WorkersCompNoteParentId?: number;
    NoteParentId?: number;
    InHouseClaimNumber?: string;
    InHouseClaimFileDate?: string;
    InHouseClaimStatusCv?: number;
    EmployeePhone?: string;

    // Display Attributes
    Ethos_UserIdDisplay?: string;
    DepartmentIdDisplay?: string;
    JobNumberIdDisplay?: string;
    WorksiteTypeCvDisplay?: string;
    AttachmentIdDisplay?: string;
    AccidentTypeCvDisplay?: string;
    BodySideCvDisplay?: string;
    BodyPartCvDisplay?: string;
    InjuryTypeCvDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    EmployeeStateDisplay?: string;
    AccidentStateDisplay?: string;
    ClaimStatusCvDisplay?: string;
    WorkersCompAttachmentIdDisplay?: string;
    WorkersCompNoteParentIdDisplay?: string;
    NoteParentIdDisplay?: string;
    InHouseClaimStatusCvDisplay?: string;

    // Relations
    InjuryTypeCvCodeValue? : CodeValueEntity;
    AccidentTypeCvCodeValue? : CodeValueEntity;
    BodyPartCvCodeValue? : CodeValueEntity;
    BodySideCvCodeValue? : CodeValueEntity;
    WorksiteTypeCvCodeValue? : CodeValueEntity;
    ClaimStatusCvCodeValue? : CodeValueEntity;
    InHouseClaimStatusCvCodeValue? : CodeValueEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    CreatedbyEthosEthosUser? : EthosUserEntity;
    EthosEthosUser? : EthosUserEntity;
    DepartmentIdEthosWachterDepartment? : EthosWachterDepartmentEntity;
    MedicalRecord? : MedicalRecordEntity[];
    RoWorkplaceAccident? : RoWorkplaceAccidentEntity;
    RoWorkplaceAccidentNotes? : RoWorkplaceAccidentNotesEntity[];
    WageExpense? : WageExpenseEntity[];
}

    // Lookup Value Enums  {
export enum CodeValueAccidentType {
        HitAndRun = 203,
        Moving = 204,
        NotAtFault = 205,
        ParkingLot = 206,
        Wildlife = 207,
        BreakIn = 335,
        Incident = 341,
        NearMiss = 342,
    }

export enum CodeValueBusinessPlanReviewAccidentType {
        Vehicle = 138,
        Onsite = 140,
    }

export enum CodeValueAccidentTypeWorkplace {
        Accident = 294,
        NearMiss = 295,
        PropertyDamage = 296,
        IncidentOnly = 297,
    }

// Excluding lookup workplaceAccident All Items because it contains 948 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
// Excluding lookup roWorkplaceAccident All Items because it contains 906 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
export enum RoWorkplaceAccidentNotesAllItems {
        WeaverReneeAug12023449PMTEstWeaverReneeAug12023449PMWorkingLateBlaHBLAH = 273,
        HuffordMarkJul3120231116AMZxc = 931,
        McmillanRandyFeb222024148PMAfdsfadsfMcmillanRandyFeb222024151PMAfdsafdsfdsafdsa = 932,
        McmillanRandyFeb222024142PMDdsadasdfdsaMcmillanRandyFeb222024143PMFafdsfdsafdsfdsasfdsafdasfdsafs = 933,
    }

export enum EthosWachterDepartmentAllItems {
        WCSolutionDesignTeam = 3,
        WECElectricalManagement = 26,
        WECProjectsCommercial = 27,
        WECIndustrialPower = 28,
        WECService = 29,
        WECStJoeMO = 30,
        WECLowellARElectric = 31,
        WCExecutives = 32,
        NWRollout = 39,
        NWNationwideServiceProjects = 40,
        STFContractStaffing = 41,
        WCSales = 42,
        STPPhysicalSecurity = 44,
        INTLCanada = 45,
        INTLLeedsUK = 46,
        WCInformationTechnology = 47,
        INTLPuertoRico = 64,
        WCAccounting = 65,
        WCHumanResources = 66,
        WCOperations = 71,
        STPEmergingTechnologiesOLD = 74,
        STPSustainableEnergyOLD = 75,
        WCFacilities = 76,
        WECControls = 79,
        WTSNetworkEngineeringPrevious = 81,
        WTSPhysicalSecurityPrevious = 83,
        INTLCostaRica = 89,
        UKIreland = 91,
        UKLeedsUK = 92,
        LBUAtlantaGA = 93,
        LBUCharlotteNC = 94,
        LBUCincinnatiOH = 95,
        LBUColumbusOH = 96,
        LBUDallasTX = 97,
        LBUIrvineCA = 98,
        LBULenexaKS = 99,
        LBULowellAR = 100,
        LBUNashvilleTN = 101,
        LBUOrlandoFL = 102,
        LBUPhiladelphiaPA = 103,
        NWElectricalService = 104,
        LBUTulsaOK = 105,
        STPProfessionalServices = 106,
        WECDecaturIL = 107,
        WCITServices = 108,
        WECEngineering = 109,
        WECHoustonTX = 110,
        WSCWachterStaffingCorporate = 111,
        WECDallasTX = 112,
        WECColorado = 113,
        STFLBUStaffingCincinnatiLBU = 114,
        STFLBUStaffingNashvilleLBU = 115,
        WECIndustrialTechnology = 116,
        WECIndustrialNationwideProjects = 117,
        LBUDenverCO = 118,
        STFLBUStaffingAtlantaLBU = 119,
        STFLBUStaffingCharlotteLBU = 120,
        STFLBUStaffingDallasLBU = 121,
        STFLBUStaffingIrvineLBU = 122,
        STFLBUStaffingLowellLBU = 123,
        STFLBUStaffingPhiladelphiaLBU = 124,
        STFLBUStaffingSeattleLBU = 125,
        STFNWStaffingNSP = 126,
        STFNWStaffingRollout = 127,
        STFWECStaffingIndustrialPower = 128,
        STFWECStaffingIndustrialNationwideProjects = 129,
        STFWECStaffingIndustrialTech = 130,
        STFWECStaffingElectricService = 131,
        WTSIOT = 132,
        WECElectricalService = 133,
        LBUSeattleWA = 134,
        STFWCStaffingIT = 135,
        STFWCStaffingOperations = 136,
        STFWCStaffingHR = 137,
        WCRD = 138,
        LBUPhoenixAZ = 139,
        LBUSanJoseCA = 140,
        STFLBUStaffingSanJoseLBU = 141,
        STFWTSStaffingIOT = 142,
        STFWTSStaffingPhysicalSecurity = 143,
        STFWTSStaffingNetworkEngineering = 144,
        WTSWTSWAVE = 145,
        LBULBUSupport = 146,
        STFLBUStaffingLBUSupport = 147,
        STFWTSStaffingWAVE = 148,
        STFWCStaffingAccounting = 149,
        WTSIntegration = 160,
        WTSNetworkEngineering = 161,
        WTSPhysicalSecurity = 162,
        WTSProjectManagement = 163,
        WTSPurchasing = 164,
        WTSSolutionsEngineering = 165,
        WTSWarehouse = 166,
        WTSWTSManagement = 167,
        WTSHelpdesk = 168,
        STFLBUStaffingOrlandoLBU = 169,
        STFWCStaffingSales = 170,
    }

export enum EthosWachterDepartmentByDivision {
    }

export enum EthosWachterDepartmentAllItemsSimple {
        SolutionDesignTeam = 3,
        ElectricalManagement = 26,
        ProjectsCommercial = 27,
        IndustrialPower = 28,
        Service = 29,
        StJoeMO = 30,
        LowellARElectric = 31,
        Executives = 32,
        Rollout = 39,
        NationwideServiceProjects = 40,
        ContractStaffing = 41,
        Sales = 42,
        PhysicalSecurity = 44,
        Canada = 45,
        LeedsUK = 46,
        InformationTechnology = 47,
        PuertoRico = 64,
        Accounting = 65,
        HumanResources = 66,
        Operations = 71,
        EmergingTechnologiesOLD = 74,
        SustainableEnergyOLD = 75,
        Facilities = 76,
        Controls = 79,
        NetworkEngineeringPrevious = 81,
        PhysicalSecurityPrevious = 83,
        CostaRica = 89,
        Ireland = 91,
        // Duplicate property Name found
        LeedsUK_92 = 92,
        AtlantaGA = 93,
        CharlotteNC = 94,
        CincinnatiOH = 95,
        ColumbusOH = 96,
        DallasTX = 97,
        IrvineCA = 98,
        LenexaKS = 99,
        LowellAR = 100,
        NashvilleTN = 101,
        OrlandoFL = 102,
        PhiladelphiaPA = 103,
        ElectricalService = 104,
        TulsaOK = 105,
        ProfessionalServices = 106,
        DecaturIL = 107,
        ITServices = 108,
        Engineering = 109,
        HoustonTX = 110,
        WachterStaffingCorporate = 111,
        // Duplicate property Name found
        DallasTX_112 = 112,
        Colorado = 113,
        StaffingCincinnatiLBU = 114,
        StaffingNashvilleLBU = 115,
        IndustrialTechnology = 116,
        IndustrialNationwideProjects = 117,
        DenverCO = 118,
        StaffingAtlantaLBU = 119,
        StaffingCharlotteLBU = 120,
        StaffingDallasLBU = 121,
        StaffingIrvineLBU = 122,
        StaffingLowellLBU = 123,
        StaffingPhiladelphiaLBU = 124,
        StaffingSeattleLBU = 125,
        StaffingNSP = 126,
        StaffingRollout = 127,
        StaffingIndustrialPower = 128,
        StaffingIndustrialNationwideProjects = 129,
        StaffingIndustrialTech = 130,
        StaffingElectricService = 131,
        IOT = 132,
        // Duplicate property Name found
        ElectricalService_133 = 133,
        SeattleWA = 134,
        StaffingIT = 135,
        StaffingOperations = 136,
        StaffingHR = 137,
        RD = 138,
        PhoenixAZ = 139,
        SanJoseCA = 140,
        StaffingSanJoseLBU = 141,
        StaffingIOT = 142,
        StaffingPhysicalSecurity = 143,
        StaffingNetworkEngineering = 144,
        WTSWAVE = 145,
        LBUSupport = 146,
        StaffingLBUSupport = 147,
        StaffingWAVE = 148,
        StaffingAccounting = 149,
        Integration = 160,
        NetworkEngineering = 161,
        // Duplicate property Name found
        PhysicalSecurity_162 = 162,
        ProjectManagement = 163,
        Purchasing = 164,
        SolutionsEngineering = 165,
        Warehouse = 166,
        WTSManagement = 167,
        Helpdesk = 168,
        StaffingOrlandoLBU = 169,
        StaffingSales = 170,
    }

// Excluding lookup roEthos_User All Items because it contains 10000 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
// Excluding lookup roEthos_UserOriginal All Items because it contains 10000 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
// Excluding lookup roEthos_User Active Only because it contains 2052 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
// Excluding lookup roEthos_User All (Active then Inactive) because it contains 10000 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
// Excluding lookup VehicleAccident All Items because it contains 1403 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
// Excluding lookup Vehicle All Items because it contains 2168 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
// Excluding lookup roVehicleAccidents All Items because it contains 1403 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
export enum CodeValueFleetVehicleStatus {
        Donated = 103827,
        ForSale = 103829,
        OnLoan = 103830,
        Sold = 103831,
        Totaled = 103832,
        Active = 103841,
    }

export enum CodeValueFleetVehicleType {
        Bucket = 103821,
        Sedan = 103822,
        SUV = 103823,
        Trailer = 103824,
        Truck = 103825,
        Van = 103826,
    }

export enum CodeValueFleetVehicleCondition {
        UsedExcellent = 103932,
        UsedFair = 103933,
        UsedGood = 103934,
        UsedPoor = 103935,
    }

export enum CodeValueVehicleAccidentFormVersion {
        Legacy = 103944,
        CurrentVersion = 103945,
    }

export enum CodeValueVehicleAccidentLineOfBusiness {
        AutoPhysicalDamage = 103946,
        AutoLiability = 103947,
    }




